import * as actionTypes from "../constants/storeContants";

export const storeReducers = (state = { store: "" }, action) => {
  switch (action.type) {
    case actionTypes.FETCHSTORE:
      return action.payload;
    default:
      return state;
  }
};
